var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _circle3, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManConfirmingYellowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 90,
  "data-name": "Layer 1",
  viewBox: "0 0 761 514.949"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M13.553 499.949H741v2H13.553z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 500.949,
  r: 14,
  fill: "#3f3d56"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 747,
  cy: 500.949,
  r: 14,
  fill: "#3f3d56"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M408.728 501h-285a9.01 9.01 0 0 1-9-9V9a9.01 9.01 0 0 1 9-9h285a9.01 9.01 0 0 1 9 9v483a9.01 9.01 0 0 1-9 9m-285-499a7.01 7.01 0 0 0-7 7v483a7.01 7.01 0 0 0 7 7h285a7.01 7.01 0 0 0 7-7V9a7.01 7.01 0 0 0-7-7Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M305.228 29h-78a1 1 0 0 1 0-2h78a1 1 0 0 1 0 2M375.728 465h-220a9.01 9.01 0 0 1-9-9V64a9.01 9.01 0 0 1 9-9h220a9.01 9.01 0 0 1 9 9v392a9.01 9.01 0 0 1-9 9m-220-408a7.01 7.01 0 0 0-7 7v392a7.01 7.01 0 0 0 7 7h220a7.01 7.01 0 0 0 7-7V64a7.01 7.01 0 0 0-7-7ZM420.228 103a4.505 4.505 0 0 1-4.5-4.5v-19a4.5 4.5 0 0 1 9 0v19a4.505 4.505 0 0 1-4.5 4.5m0-26a2.503 2.503 0 0 0-2.5 2.5v19a2.5 2.5 0 0 0 5 0v-19a2.503 2.503 0 0 0-2.5-2.5M420.228 134a4.505 4.505 0 0 1-4.5-4.5v-19a4.5 4.5 0 0 1 9 0v19a4.505 4.505 0 0 1-4.5 4.5m0-26a2.503 2.503 0 0 0-2.5 2.5v19a2.5 2.5 0 0 0 5 0v-19a2.503 2.503 0 0 0-2.5-2.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M340.728 212.008h-150a6 6 0 0 1 0-12h150a6 6 0 0 1 0 12M340.728 239.008h-150a6 6 0 0 1 0-12h150a6 6 0 0 1 0 12M340.728 266.008h-150a6 6 0 0 1 0-12h150a6 6 0 0 1 0 12"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "M287.33 185.008h-48.504a11 11 0 0 1 0-22h48.505a11 11 0 0 1 0 22"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M219.692 356.992a21.787 21.787 0 1 1 21.787-21.787 21.81 21.81 0 0 1-21.787 21.787m0-41.28a19.494 19.494 0 1 0 19.493 19.493 19.494 19.494 0 0 0-19.493-19.493"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "M219.73 342.747a2.5 2.5 0 0 1-1.767-.734l-8.005-8.005a2.5 2.5 0 0 1 0-3.536l.414-.415a2.505 2.505 0 0 1 3.536 0l4.15 4.15a1.5 1.5 0 0 0 2.288-.197l17.697-25.15a2.5 2.5 0 0 1 3.483-.606l.482.339a2.5 2.5 0 0 1 .605 3.483l-20.838 29.61a2.5 2.5 0 0 1-1.83 1.051q-.108.01-.216.01"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M305.693 356.992a21.787 21.787 0 1 1 21.787-21.787 21.81 21.81 0 0 1-21.787 21.787m0-41.28a19.494 19.494 0 1 0 19.493 19.493 19.494 19.494 0 0 0-19.493-19.493"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M312.674 345.17h-.004a2.48 2.48 0 0 1-1.766-.735l-4.149-4.159a1.537 1.537 0 0 0-2.124 0l-4.149 4.16a2.48 2.48 0 0 1-1.766.735h-.004a2.48 2.48 0 0 1-1.765-.73l-.415-.413a2.504 2.504 0 0 1-.006-3.535l4.167-4.18a1.5 1.5 0 0 0 0-2.118l-4.262-4.277a2.5 2.5 0 0 1 .005-3.534l.415-.414a2.48 2.48 0 0 1 1.765-.73h.004a2.48 2.48 0 0 1 1.767.735l4.244 4.257a1.54 1.54 0 0 0 2.124 0l4.244-4.257a2.48 2.48 0 0 1 1.767-.735h.004a2.48 2.48 0 0 1 1.765.73l.415.414a2.5 2.5 0 0 1 .005 3.534l-4.262 4.276a1.503 1.503 0 0 0 0 2.118l4.166 4.181a2.5 2.5 0 0 1-.005 3.534l-.415.414a2.48 2.48 0 0 1-1.765.73"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#a0616a",
  d: "M601.462 488.504h12.785l6.085-49.313h-18.87z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M638.903 500.375h-40.18v-15.524h24.871a15.31 15.31 0 0 1 15.31 15.309z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#a0616a",
  d: "m605.956 412.091-8.819 9.257-39.901-29.608 13.015-13.662z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m588.046 425.596 17.154-18.008 11.24 10.708-27.713 29.093-.156-.149a15.31 15.31 0 0 1-.525-21.644"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#a0616a",
  d: "M694.945 276.99a10.486 10.486 0 0 0-5.017-15.278l-50.195-127.928-19.566 11.714 55.76 122.729a10.543 10.543 0 0 0 19.018 8.762M504.42 286.16a10.486 10.486 0 0 0 9.417-13.034l74.051-115.767-20.973-8.954-66.573 117.216a10.543 10.543 0 0 0 4.078 20.538"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M639.239 264.18 626.13 458.984l-31.324-2.764-6.449-143.721-17.505 61.726-37.773 2.764 14.951-122.024Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m565.326 365.013 5.527 9.213 38.695 26.717-27.64 14.741s-53.434-29.481-48.828-38.694Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "m666.668 185.361-10.904-30.73a54.86 54.86 0 0 0-28.383-31.311 78.5 78.5 0 0 0-46.075-2.522l-3.968.985a76.7 76.7 0 0 0-29.081 14.048c-6.72 5.297-12.765 12.004-13.302 19.218l-.014.045c-1.86 8.156-2.782 50.536-2.782 50.536h16.416l-2.596 57.12.21-.414s94.682 17.918 94.682 8.705V212.08l1.941-21.35Z"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 578.291,
  cy: 86.577,
  r: 26.239,
  fill: "#a0616a"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m576.052 75.696-22.064-.07c-2.564-.008-5.362-.099-7.315-1.76-2.941-2.5-2.448-7.22-.873-10.745 4.386-9.816 15.273-16.05 26.02-15.76s20.923 6.65 26.714 15.708 7.354 20.5 5.173 31.027a33.83 33.83 0 0 0-27.66-19.286Z"
})));
export default SvgManConfirmingYellowIcon;